import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'

interface LoadingProps {
  title?: string
  subtitle?: string
}

const Loading: React.FC<LoadingProps> = ({
  title = 'Bán hàng',
  subtitle = 'Đang tải dữ liệu...',
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        color: 'text.primary',
      }}
    >
      <Box
        sx={{
          bgcolor: 'rgba(255, 255, 255, 0.8)',
          borderRadius: 2,
          p: 4,
          textAlign: 'center',
          boxShadow: 2,
          border: '1px solid',
          borderColor: 'divider',
          maxWidth: 320,
          width: '90%',
        }}
      >
        <Box
          sx={{
            width: 60,
            height: 60,
            mx: 'auto',
            mb: 2,
            bgcolor: 'action.hover',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress size={32} sx={{ color: 'primary.main' }} />
        </Box>
        <Typography variant="h6" sx={{ mb: 1, fontWeight: 500 }}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      </Box>
    </Box>
  )
}

export default Loading
